import { useState } from 'react';
import { AlertCircle, ArrowRight } from 'lucide-react';
import { Link } from '@tanstack/react-router';
import { Button } from '@/components/ui/button';
import { GoogleAdAccountSelectionModal } from '@/components/glitch-ui/google-ad-account-selection-modal';

export function CampaignVisibilityWarning() {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleModalClose = () => {
    setIsModalOpen(false);
    // Note: Modal handles page reload when account is selected
  };

  return (
    <>
      <div className="space-y-6 pt-8">
        <div className="bg-amber-50 border-l-4 border-l-amber-400 rounded-lg p-6">
          <div className="flex items-start gap-4">
            <div className="bg-white rounded-lg shadow p-3">
              <AlertCircle className="h-6 w-6 text-amber-500" />
            </div>
            <div className="flex-1">
              <h3 className="text-lg font-semibold text-gray-900 mb-2">Campaigns Not Viewable</h3>
              <div className="flex items-start justify-between">
                <div className="flex-1">
                  <p className="text-gray-900">
                    Please{' '}
                    <button 
                      onClick={() => setIsModalOpen(true)}
                      className="text-blue-600 hover:underline cursor-pointer"
                    >
                      select a Google Ads account
                    </button>{' '}
                    with campaigns in this organization. You can also learn about{' '}
                    <a 
                      href="https://support.google.com/google-ads/answer/6372672" 
                      target="_blank" 
                      rel="noopener noreferrer"
                      className="text-blue-600 hover:underline"
                    >
                      Google Ads permissions
                    </a>{' '}
                    or{' '}
                    <Link
                      to="/new/campaign"
                      className="text-blue-600 hover:underline"
                    >
                      create new campaigns
                    </Link> anyway.
                  </p>
                </div>
                <Button 
                  size="lg"
                  onClick={() => setIsModalOpen(true)}
                  className="w-[280px] py-6 bg-[#290BD9] hover:bg-[#2309C5] text-white shadow-lg flex items-center justify-center space-x-2 disabled:opacity-50 disabled:cursor-not-allowed ml-6"
                >
                  <span>SELECT ACCOUNT</span>
                  <ArrowRight className="h-4 w-4" />
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      <GoogleAdAccountSelectionModal 
        isOpen={isModalOpen} 
        onClose={handleModalClose} 
      />
    </>
  );
}